var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 18.0014V28.332H0.333313C0.3329 26.7039 0.705208 25.0972 1.42171 23.6352C2.13821 22.1732 3.1799 20.8946 4.46694 19.8974C5.75398 18.9002 7.25221 18.2109 8.84685 17.8822C10.4415 17.5536 12.0902 17.5943 13.6666 18.0014ZM11 16.332C6.57998 16.332 2.99998 12.752 2.99998 8.33203C2.99998 3.91203 6.57998 0.332031 11 0.332031C15.42 0.332031 19 3.91203 19 8.33203C19 12.752 15.42 16.332 11 16.332ZM21.6666 21.6654H25.6666V24.332H21.6666V28.9987L15 22.9987L21.6666 16.9987V21.6654Z",
    fill: "#7E00C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActiveIcon);
export default __webpack_public_path__ + "static/media/usersActiveIcon.be7c07cf70bfcd381b6aa21a071f60c1.svg";
export { ForwardRef as ReactComponent };